import React from "react";
import { Link } from "react-router-dom";
import "../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { config } from "../config";

function Header({ isTransparent = false }) {
  return (
    <header
      className={`flex flex-row md:flex-row justify-between items-center p-4 text-white ${
        isTransparent ? "bg-transparent" : `bg-${config.primaryColor}`
      }`}
    >
      <Link to="/" className="flex items-center gap-4">
        <img src={config.logoSrc} alt="Logo" className="h-8 w-auto" />
        <span className="text-lg md:text-xl font-bold">
          {config.siteName}
        </span>
      </Link>
      <div className="flex items-center text-sm space-x-2 md:space-x-4">
        <Link
          to="/my/manage-booking"
          className="font-bold flex items-center space-x-2 bg-transparent border-gray-300 border text-white px-3.5 py-2.5 rounded-full hover:bg-white/10 transition-colors"
        >
          <FontAwesomeIcon icon={faSearch} />
          <span className="hidden md:block lg:block">Manage my booking</span>
        </Link>
      </div>
    </header>
  );
}

export default Header;
